import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import {
    settheinternaldepartmentRemarksgetaction,
    setthereassignandAssignRejectDataActions,
    settheAssignAndReassigns,
} from "../../../../Redux/Slice"
import { useNavigate } from 'react-router-dom';

const TicketRejections = () => {
     const dispatch = useDispatch()
     const state = useSelector((state)=>state);
      const navigate = useNavigate()

    const HandleTheTicketRejectionFlow = () => {
        dispatch(settheAssignAndReassigns(2))
        // dispatch(settheTicketReassignIds(TickeREtrievdatas.client_ticket_id))
        // dispatch(settheTicketStatusNames(TickeREtrievdatas?.status == 0 ? "Open" :
        //     TickeREtrievdatas?.status == 1 ? "In Progress" :
        //         TickeREtrievdatas?.status == 2 ? "Review" :
        //             TickeREtrievdatas?.status == 3 ? "Resolved" : "Reopened"))

        const payload = {
            data: {
                ticket_assign_mode: "reject"
            },
            // EditId: state.StateManagementOverallCall.TicketIDS
            EditId: state.StateManagementOverallCall.ReassignTicketIds,
            ticket_assign_mode: "Reject",
            Funcations: () => {
                navigate("/internal_ticketview")      
              },



        }
        dispatch(setthereassignandAssignRejectDataActions(payload))

    }
  return (
    <>

    <div className="RoleCreatePopup">
        <div className="BeforePopUp">
            <div className="RolePopups" style={{ width: "30%" }}>
                <div className="asds">
                    <div class="ModalHeader" style={{ background: "transparent", display: "flex", justifyContent: "flex-end", border: "none" }}>
                        <div className="CloseIcon" onClick={(e) => {
                            // setRejectionPopups(false);
                            navigate("/internal_ticketview")      

                        }}>
                            <CloseOutlinedIcon />
                        </div>
                    </div>
                    <div class="row g-3 ConfirmProceeds" onSubmit={(e) => e.preventDefault()}>
                        <h3>Confirm to proceed</h3>
                        <div className='InnerConfirmationPopups'>
                            <p>{"Are you sure to move this ticket to 'Reject'?"}</p>
                        </div>
                    </div>

                    <div
                        className="RoleButton confimpopupdesigns"
                        style={{
                            display: "flex",
                            gap: "15px",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <button
                            class="btn  SaveBtnNo"
                            type="submit"
                            onClick={() => {
                                // setRejectionPopups(false)
                                navigate("/internal_ticketview")      

                            }
                            }

                        >
                            {"No"}
                        </button>

                        <button
                            class="btn  SaveBtn"
                            type="submit"
                            onClick={() => {
                                HandleTheTicketRejectionFlow();
                            }
                            }

                        >
                            {"Reject"}
                        </button>

                    </div>



                </div>
            </div>
        </div>
    </div>

</>  )
}

export default TicketRejections